export const SELLER_MODAL_ID = 'seller-modal'
export const SELLER_MODAL_CONTAINER_ID = 'seller-modal-container'
